<div
  class="module-toggles ignore-export"
  role="group"
  aria-labelledby="statement-module-toggles-label">
  <span id="statement-module-toggles-label" class="module-toggles__label">Mostrar</span>
  @for (key of keys; track key) {
    <button
      type="button"
      class="module-toggles__pill"
      [class.module-toggles__pill--on]="modules.isOn(key)"
      [attr.aria-pressed]="modules.isOn(key)"
      [title]="titleFor(key)"
      (click)="modules.toggle(key)">
      <i
        class="pi"
        [class.pi-check]="modules.isOn(key)"
        [class.pi-plus]="!modules.isOn(key)"
        aria-hidden="true"></i>
      <span>{{ labels[key] }}</span>
    </button>
  }
  <!-- "Restaurar padrão" (card 3863, pedido do Victor em 03/11/2026): só o tamanho, ou a visão completa
       (módulos padrão + tamanho). Sem recarregar a página. -->
  <app-button-menu
    class="module-toggles__restore"
    theme="white"
    size="small"
    icon="refresh"
    label="Restaurar padrão"
    title="Voltar a tela da DFP ao padrão"
    [items]="restoreItems" />
</div>
